import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=65a2843e&scoped=true&lang=pug"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"
import style0 from "./invoice.vue?vue&type=style&index=0&id=65a2843e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2843e",
  null
  
)

export default component.exports